import gql from 'graphql-tag'

export default {
  checkoutOrderMutation: gql`
    mutation CheckoutOrder(
      $storeId: ID!
      $email: String!
      $items: [CheckoutOrderItemInput]!
      $isPickup: Boolean
      $shipping: CheckoutOrderShippingInput
      $buyerDeviceId: String!
      $paymentOrigin: String!
      $longitude: Float
      $latitude: Float
      $ct: String
      $isTablePickup: Boolean
      $tableNumber: String
    ) {
      checkoutOrder(
        input: {
          storeId: $storeId
          email: $email
          items: $items
          isPickup: $isPickup
          shipping: $shipping
          buyerDeviceId: $buyerDeviceId
          paymentOrigin: $paymentOrigin
          longitude: $longitude
          latitude: $latitude,
          ct: $ct
          isTablePickup: $isTablePickup
          tableNumber: $tableNumber
        }
      ) {
        checkoutUrl
        paypalOrderId
        isFromStock
        autoCancelDate
        errorDebugId
        errors {
          field
          messages
          path
        }
      }
    }
  `,
  checkoutOrderPayMutation: gql`
    mutation CheckoutOrderPay($paypalOrderId: String!) {
      checkoutOrderPay(input: { paypalOrderId: $paypalOrderId }) {
        success
      }
    }
  `
}
